import { createSelector } from 'reselect';
import pick from 'lodash/pick';
import values from 'lodash/values';
// import { debug } from '../../../utils';
// const log = debug('lego:models/Search');

const paramsFromProps = ({location, mapState, center}) => {
  //log('Search props: ', props);
	const map = mapState && mapState.mapComponent && mapState.mapComponent()
	const _center = map && map.getCenter()
	const position = _center ? {latitude: _center.lat(), longitude: _center.lng()} : location
  if (!position) return {latitude: 1, longitude: 1, sort: 'distance', keyword:''};
	const { q: keyword='',
				 //p: position='',
//            latitude: lat, longitude: lng
       } = location.query;
	  const sort = location.query.sort || keyword.length > 0 ? 'relevance' : 'distance'
    // if position is in the url, it is of the form [lat, lng]
    // const { latitude, longitude } = {
    //     latitude: parseFloat(lat) || userPosition.latitude,
    //     longitude: parseFloat(lng) || userPosition.longitude
    // };
    // const { latitude, longitude } = mapState.map_location;
    // const { latitude, longitude } = userPosition;
    // const { latitude, longitude } = position.length > 0 ? position.split(',') : userPosition;

    const params = { sort, keyword };
    return params;
};

const paramsFromState = state => paramsFromProps({location: state.routing.locationBeforeTransitions} as any)

const getQuery = (state) => state.queries;
const getQueryByKeyword = (state, keyword) => getQuery(state)[keyword];
const getQueryByParams = (state, params) => getQueryByKeyword(state, params && params.keyword);
import { getPlaces } from '../Places';

import orderBy from 'lodash/orderBy'
import get from 'lodash/get'
import { getDistance } from 'geolib'
import { getUserPosition, getCenter } from '../Location';
const getPosition = state => getUserPosition(state.userPosition)
const distanceFrom = frm => place => getDistance(place.location.position, frm)
const sortByDistance = distance => (p1: any, p2: any) => distance(p1) - distance(p2)
const getResults = createSelector(
  [getPlaces, getQueryByParams, getPosition, paramsFromState ] as any, ((places, query, position, params) => {
		if (!query) { return { inProgress: false }; };
		const { data, inProgress } = query;
		const picked_data = values(pick(places, data)).map(place => (place as any).data)
		const distanceTo = distanceFrom(position)
		return {
			data: params.sort.toLowerCase() === 'distance'
				? orderBy(picked_data, distanceTo)
				: orderBy(picked_data, [
					place => get(place, 'arb.rating.personalized') || 0,
					place => get(place, 'arb.rating.average') || 0,
					distanceTo,
				], ['desc', 'desc', 'asc']),
			inProgress,
		}
	}) as any
);

const getLatestResults = getResults;

// const getLatestResults = createSelector(
//   [getPlaces, getLatestQuery] as any, ((places, query) => {
// 		if (!query) { return { inProgress: false }; };
// 		const { data, inProgress  } = query;
// 		return {
// 			data: values(pick(places, data)),
// 			inProgress,
// 		}
// 	}) as any
// );

/* const placeSelector = (places, place_ids) => pickBy(places, place_ids);
 * const querySelector = (queries, query) => queries[query];
 */

import { search } from './actions'
import omit from 'lodash/omit'
import mapKeys from 'lodash/mapKeys'
const renameKeys = (collection, rename_map) => mapKeys(collection, (value, key) => rename_map[key] || key)
function generateQueryParams(query) {
	const _query = {...query, ...(query && query.position)}
  const params = renameKeys(omit(_query, ['position', 'latitude', 'lat', 'lng', 'longitude', 'zoom']), {keyword: 'q'}) as any
	const keyword = query && query.keyword
	return keyword ? params : omit(params, ['q', 'sort'])
}

export { search, getResults, getLatestResults, paramsFromProps, generateQueryParams };



// WEBPACK FOOTER //
// ./src/app/models/Search/index.ts